export  const iSoToDate = (dataIso: string | Date) => {
  if (dataIso === '') return; 
  return new Date(String(dataIso).slice(0, -1));
  }